import Vue from 'vue'
import Router from 'vue-router'
import earth from '@/components/base/earth'
import forest from '@/components/forest/forest'

Vue.use(Router)

const router = new Router({
    // mode: 'history',   // 去除路由中的 # 号
    routes: [
        // {
        //     path: '/',
        //     name: 'forest',
        //     component: forest,
        // },
        {
            path: "/",
            name: "earth",
            component: earth,
            children: [
                {
                    path: "/",
                    name: "forest",
                    component: forest,
                    meta: {
                        title: "森林经营展示系统",
                        icon: "./static/forest/title.png"
                    }
                },
                {
                    path: "/forest",
                    name: "forest",
                    component: forest,
                    meta: {
                        title: "森林经营展示系统",
                        icon: "./static/forest/title.png"
                    }
                }
            ]
        }
    ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js